import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';

/**
 *
 */
export default class Loader extends Base {
  static config = {
    name: 'Loader',
    refs: ['overlay', 'logoWrapper', 'logo', 'header', 'topHeader'],
  };

  /**
   * Get a diamond clip-path with equal side lengths
   * @param {number} size Half-diagonal as a fraction of the smallest viewport dimension
   * @returns {string} CSS polygon clip-path
   */
  getDiamondClipPath(size) {
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const d = Math.min(vw, vh) * size;
    const top = ((vh / 2 - d) / vh) * 100;
    const bottom = ((vh / 2 + d) / vh) * 100;
    const left = ((vw / 2 - d) / vw) * 100;
    const right = ((vw / 2 + d) / vw) * 100;

    return `polygon(50% ${top}%, ${right}% 50%, 50% ${bottom}%, ${left}% 50%)`;
  }

  /**
   *
   */
  mounted() {
    if (!this.$refs.overlay) return;
    this.tl = gsap.timeline({
      onComplete: () => {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { loader_seen: 'true' } }),
        });

        document.body.classList.remove('loader');
        this.$refs.logoWrapper.remove();
      },
    });

    this.tl.to(this.$refs.logo, {
      y: 0,
      duration: 1,
      ease: 'cubic.inOut',
    });

    this.tl.to(this.$refs.overlay, {
      delay: 1,
      clipPath: this.getDiamondClipPath(0.4),
      duration: 0.5,
      ease: 'none',
    });

    this.tl.to(this.$refs.overlay, {
      clipPath: 'polygon(170% -100%, 200% 170%, -70% 200%, -100% -70%)',
      duration: 0.5,
      ease: 'none',
    });

    this.tl.to(
      [this.$refs.topHeader, this.$refs.header],
      {
        opacity: 1,
        y: 0,
        stagger: 0.1,
        duration: 0.6,
        ease: 'cubic.out',
      },
      '-=0.7',
    );
  }
}
